<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v">For Meredith and Connor</a></p><a id="page_v">
</a><p class="deda"><a id="page_v">At least your middle-school years were not <span class="txit">this</span> crazy</a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f1af68ea